export default {
  api: {
    login: {
      url: "/auth/login",
      method: "post"
    },
    resetPassword: {
      url: "/auth/resetPassword",
      method: "post"
    },

    register: {
      url: "/auth/register",
      method: "post"
    },
    smsCode: {
      url: "/resource/sms/code",
      method: "get"
    },
    code: {
      url: "/auth/code",
      method: "get"
    },
    checkPhoneExist: {
      url: "/auth/checkPhoneExist",
      method: "get"
    },
    verifyCode: {
      url: "/universal/verify/sms/code",
      method: "get"
    },
    advSearch: {
      url: "/universal/search/advSearch",
      method: "get"
    }
  }
};
